// angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// cc-common imports
import { IconConstants } from 'cc-common';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';

// service imports
import { CiraHelpService } from '../../../_services/shared-services/cira-help.service';

// model imports
import { WorkflowChecklistEditorResultDto } from '../../_models/workflow-check-list-editor-result-dto';
import { WorkflowCheckListItemResultDto } from '../../_models/workflow-check-list-item-result-dto';
import { WorkflowCheckListRawDto } from '../../_models/workflow-check-list-raw-dto';

// constant imports
import { WorkflowConstants } from '../../_constants/worflow-constants';

@Component({
    selector: 'app-workflow-checklist-editor',
    templateUrl: './workflow-checklist-editor.component.html',
    styleUrls: ['./workflow-checklist-editor.component.scss']
})
export class WorkflowChecklistEditorComponent implements OnInit {
    @ViewChild('vendorChecklistPopup', { static: false }) vendorChecklistPopup: DxPopupComponent;

    @Input() workflowId: number;
    @Input() communityId: number;
    @Input() checklistItems: Array<WorkflowCheckListItemResultDto> = [];
    @Input() viewOnly = false;
    @Input() workflowStatus: string;
    @Input() notifyChanges = false;

    @Output() onClose = new EventEmitter<void>();
    @Output() onNotifyAndClose = new EventEmitter<WorkflowCheckListItemResultDto[]>();
    @Output() onSaveChecklist = new EventEmitter<WorkflowCheckListRawDto[]>();

    checklistEditor: WorkflowChecklistEditorResultDto;

    visible = false;
    isAccountStep = false;

    iconClose = IconConstants.CLOSE;
    iconCheck = IconConstants.CHECK;
    iconHelp = IconConstants.HELP;

    constructor(private readonly ciraHelpService: CiraHelpService) {}

    ngOnInit() {
        this.show();
        this.isAccountStep =
            this.workflowStatus.toLowerCase() === WorkflowConstants.ACCTINBOX ||
            this.workflowStatus.toLowerCase() === WorkflowConstants.ACCTINREVIEW ||
            this.workflowStatus.toLowerCase() === WorkflowConstants.HOLD;
    }

    show(): void {
        this.visible = true;
    }

    onPopupShown(): void {
        this.vendorChecklistPopup.instance.repaint();
    }

    onPopupClose(): void {
        this.closeChecklist();
    }

    onCheckListItemClick(record: WorkflowCheckListItemResultDto): void {
        this.ciraHelpService.showHelp(
            this.ciraHelpService.getHelpLink(record.helpId.toString(), null, this.communityId)
        );
    }

    onCloseClick(): void {
        this.closeChecklist();
    }

    onConfirmClick(): void {
        if (!this.notifyChanges) {
            const editedCheckList: Array<WorkflowCheckListRawDto> = this.getEditedChecklistItems();
            this.onSaveChecklist.emit(editedCheckList);
        } else {
            this.onNotifyAndClose.emit(this.checklistItems);
        }
        setTimeout(() => this.closeChecklist(), 250);
    }

    onStatusValueChanged(event: any, cellInfo: any): void {
        cellInfo.setValue(event.value);
        cellInfo.data.status = event.value;
    }

    onCommentsValueChanged(event: any, cellInfo: any): void {
        cellInfo.setValue(event.value);
        cellInfo.data.comments = event.value;
    }

    private getEditedChecklistItems(): Array<WorkflowCheckListRawDto> {
        const editedCheckList: Array<WorkflowCheckListRawDto> = [];
        this.checklistItems.forEach((item) => {
            const obj: WorkflowCheckListRawDto = new WorkflowCheckListRawDto();
            obj.id = item.id;
            obj.status = this.isAccountStep ? item['acctStatus'] : item['camStatus'];
            obj.comments = this.isAccountStep ? item['acctComments'] : item['camComments'];
            if (!!obj.status) {
                editedCheckList.push(obj);
            }
        });

        return editedCheckList;
    }

    private closeChecklist(): void {
        this.visible = false;
        this.onClose.emit();
    }
}
